import { render, staticRenderFns } from "./remarkTextComp.vue?vue&type=template&id=d4f967d2&scoped=true"
import script from "./remarkTextComp.vue?vue&type=script&lang=js"
export * from "./remarkTextComp.vue?vue&type=script&lang=js"
import style0 from "./remarkTextComp.vue?vue&type=style&index=0&id=d4f967d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f967d2",
  null
  
)

export default component.exports